'use strict';

import * as dom from './lib/dom';

const IsSafari = () =>  {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('safari') != -1) {
        if (userAgent.indexOf('chrome') > -1) {
            return false;
        } else {
            return true;
        }
    }
}

export default function(){
	window.addEventListener('load', function() {
        const bodyEl = document.querySelector('body');
        if(IsSafari) {
            dom.addClass(bodyEl, 'is-safari');
        }
  	});
}
